import { BrowserApp } from './BrowserApp.js'

/**
 * @import { JSONValue } from '../ts/Assertions.ts'
 */

/**
 * Returns the currently raised launch alert for this app,
 * or null if none.
 *
 * @typedef {Object} AlertEntry
 * @property {URL} sourceUrl - The URL of the alert source.
 * @property {string} sourceTitle - The title of the alert source.
 * @property {string} type - The alert type.
 * @property {JSONValue} value - The value associated with the alert.
 * @property {Date} created - When the alert was created.
 * @property {Date|null} expiry - When the alert expires or null if it doesn't expire.
 *
 * @return { Promise<AlertEntry | null> } raised launch alert, or null if none.
 * @throws {string} exception if alert catalog cannot be retrieved.
 */
export async function getLaunchAlert() {
  const app = await BrowserApp.getInstance()
  const origin = app.getPartyOrigin()
  const url = new URL(`${origin}/catalog`)
  url.searchParams.append('alert', '')
  const response = await fetch(url, {
    headers: {
      'X-Tabserver-Token': app.getTokenBase64(),
      'Accept': 'application/json'
    }
  })
  const json = await response.json()
  if ('error' in json) {
    throw json.error
  }

  const alert = json.ok.alert.find(
    /** @param {AlertEntry} alert */
    alert => (
      alert.type == 'LAUNCH' &&
      alert.sourceUrl == new URL(app.getAppUrl())
    )
  )
  return alert || null
}
